<template>
  <div class="nav-scroller bg-body shadow-sm">
    <nav class="nav nav-underline" aria-label="Secondary navigation">
      <slot></slot>
      <!--a class="nav-link" href="#">
        Friends
        <span class="badge bg-light text-dark rounded-pill align-text-bottom">27</span>
      </a-->
    </nav>
  </div>  
</template>

<script>
export default {
  name: "SubMenu"
}
</script>
